import { render } from "./OverlayBaseMap.vue?vue&type=template&id=28c6f294&ts=true"
import script from "./OverlayBaseMap.vue?vue&type=script&lang=ts"
export * from "./OverlayBaseMap.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__